import { useCallback } from 'react';

import { MAX_TABLE_ROWS, Table } from './table.constants';
import {
  addBelow,
  removeRow,
  addAbove,
  canShowRemoveRow,
} from './table-settings-row.utils';
import {
  DropdownDivider,
  DropdownItem,
} from 'approot/shared/dropdown/dropdown-item.style';
import TablePropertiesSettings from './table-properties-settings';
import {
  AnswerMap,
  updateAnswerMapAfterRowDelete,
  updateAnswerMapAfterRowInsert,
} from '../shared/logic/table-answer-map';

type Props = {
  rowIndex: number;
  table: Table;
  answerMap: AnswerMap;
  onMenuToggle: (isOpen: boolean) => void;
  handleUpdateTable: (table: Table, answers?: AnswerMap) => void;
};

const TableSettingsRow = ({
  rowIndex,
  table,
  answerMap,
  onMenuToggle,
  handleUpdateTable,
}: Props) => {
  const canAddRow = table.rows.length < MAX_TABLE_ROWS;
  const canRemove = canShowRemoveRow(table.rows);

  const handleRemove = useCallback(() => {
    handleUpdateTable(
      removeRow(table, rowIndex),
      updateAnswerMapAfterRowDelete(answerMap, rowIndex)
    );
  }, [rowIndex, table, answerMap, handleUpdateTable]);

  const handleAddAbove = useCallback(() => {
    handleUpdateTable(
      addAbove(table, rowIndex),
      updateAnswerMapAfterRowInsert(answerMap, rowIndex - 1)
    );
  }, [rowIndex, table, answerMap, handleUpdateTable]);

  const handleAddBelow = useCallback(() => {
    handleUpdateTable(
      addBelow(table, rowIndex),
      updateAnswerMapAfterRowInsert(answerMap, rowIndex)
    );
  }, [rowIndex, table, answerMap, handleUpdateTable]);

  return (
    <TablePropertiesSettings onMenuToggle={onMenuToggle}>
      {canAddRow && (
        <DropdownItem onClick={handleAddAbove}>Add row above</DropdownItem>
      )}
      {canAddRow && (
        <DropdownItem onClick={handleAddBelow}>Add row below</DropdownItem>
      )}
      {canRemove && canAddRow && <DropdownDivider />}
      {canRemove && (
        <DropdownItem $isNegative onClick={handleRemove}>
          Remove row
        </DropdownItem>
      )}
    </TablePropertiesSettings>
  );
};

export default TableSettingsRow;
